import { ListItemIcon, ListItemText, MenuItem } from "@mui/material"
import { useDispatch } from "react-redux"
import { setSavedAlbumsLayout, setSavedAlbumsOrder, setSortedSavedAlbums } from "../../../../actions/albumListActions";
import { getLayoutIcon, getOrderIcon } from "../../../../utils/iconUtils";
import { ORDER_LAYOUT_SELECTOR_ICON_SIZE } from "../../../../utils/constants/viewConstants";

export const AlbumLayoutItem = ({elementKey, elementValue, selectedLayout}) => {
    const dispatch = useDispatch();

    const onClick = () => {
        dispatch(setSavedAlbumsLayout(elementValue));
    }

    return (
        <AlbumLayoutOrderItem
            text={elementValue}
            icon={getLayoutIcon(elementKey)}
            onClick={onClick}
            selected={selectedLayout === elementValue}
        />
    )
}

export const AlbumOrderItem = ({elementKey, elementValue, selectedOrder}) => {
    const dispatch = useDispatch();

    const onClick = () => {
        dispatch(setSavedAlbumsOrder(elementValue));
        dispatch(setSortedSavedAlbums());
    }

    return (
        <AlbumLayoutOrderItem
            text={elementValue}
            icon={getOrderIcon(elementKey)}
            onClick={onClick}
            selected={selectedOrder === elementValue}
        />
    )
}

const AlbumLayoutOrderItem = ({text, icon, onClick, selected}) => {
    return (
        <MenuItem onClick={onClick} selected={selected}>
            <ListItemIcon sx={{fontSize: ORDER_LAYOUT_SELECTOR_ICON_SIZE}}>{icon}</ListItemIcon>
            <ListItemText>{text}</ListItemText>
        </MenuItem>
    )
}